import { IbaniUrejanje } from '../components/IbaniUrejanje';
import React, { useState } from 'react';
import { Building2, Save, AlertCircle, Loader, Upload, RefreshCw, ShieldCheck } from 'lucide-react';  // [PATCH pregled-vstop v1]
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import toast from 'react-hot-toast';
/* [PATCH nastavitve-zavihki v1] kartice Racun=placan, Zbirni kupec, Predpone internih
   stevilk, DDV konti in DDV klavzule so preseljene na stran Nastavitve
   (zavihka Prejeti/Izdani racuni). Nalaganje profila je zdaj v hooku useProfil. */
import { useProfil } from '../hooks/useProfil';



const VAT_STATUSI = ['Zavezanec', 'Mali zavezanec', 'Ni zavezanec'];
const VAT_REZIMI = ['Splošni', 'Posebna ureditev za male podjetje', 'Pavšalni'];
const VELIKOSTI = ['Mikro', 'Majhno', 'Srednje', 'Veliko'];


export function ProfilPage() {
  const { selectedCompany } = useAuthStore();
  const COMPANY_ID = selectedCompany?.id || '';
  const navigate = useNavigate();
  /* [PATCH nastavitve-zavihki v1] nalaganje in shranjevanje profila sta v skupnem
     hooku useProfil (isti GET/PUT kot prej); polja se pisejo prek set(). */
  const { data, set, shrani, saving, loading } = useProfil(COMPANY_ID);

  // [PATCH profil-osvezi v1] FURS lookup po davčni podjetja (isto kot "Preveri" v maski partnerja)
  const [osvezujem, setOsvezujem] = useState(false);
  const [osveziStevec, setOsveziStevec] = useState(0);  // [PATCH rtr-podjetje v3] sprozi RTR v IbaniUrejanje
  const osvezi = async () => {
    setOsveziStevec((n) => n + 1);  // [PATCH rtr-podjetje v3] poleg FURS osvezi tudi TRR iz AJPES
    const dav = String(data.tax_number || '').trim().replace(/^SI/i, '');
    if (!dav) { toast.error('Vpiši davčno številko.'); return; }
    setOsvezujem(true);
    try {
      const r = await api.get(`/partner-lookup?davcna=${encodeURIComponent(dav)}`);
      const d = r.data;
      if (!d || (!d.naziv && !d.ddv_id && !d.maticna)) { toast.error('Ni podatkov za to davčno.'); return; }
      const spr: any = {};
      if (d.naziv) spr.name = String(d.naziv);
      const m = d.naslov ? String(d.naslov).match(/^(.+),\s*(\d{4,5})\s+(.+)$/) : null;
      if (m) { spr.address = m[1].replace(/\s+/g, ' ').trim(); spr.postal_code = m[2]; spr.city = m[3].trim(); }
      else if (d.naslov) { spr.address = String(d.naslov); }
      if (d.maticna) spr.registration_number = String(d.maticna);
      if (d.skd) spr.skd_code = String(d.skd);
      if (d.skd_naziv) spr.skd_description = String(d.skd_naziv);
      if (d.ddv_id) spr.vat_number = String(d.ddv_id);
      if (d.vir !== 'VIES') {
        spr.vat_status = d.zavezanec_ddv ? 'Zavezanec' : 'Ni zavezanec';
        if (d.zavezanec_ddv) spr.vat_regime = 'Splošni';
      }
      Object.keys(spr).forEach((k) => set(k, spr[k]));  // [PATCH nastavitve-zavihki v1] setData -> set()
      toast.success(`Osveženo (${d.vir || 'FURS'}): ${d.naziv || d.ddv_id || dav}`);
    } catch (e: any) {
      toast.error(e?.response?.data?.detail || 'Napaka pri osveževanju.');
    } finally {
      setOsvezujem(false);
    }
  };



  if (loading) return (
    <div className="flex items-center justify-center h-64">
      <Loader className="w-8 h-8 text-blue-500 animate-spin" />
    </div>
  );

  if (!data) return (
    <div className="flex items-center justify-center h-64 text-red-500">
      <AlertCircle className="w-5 h-5 mr-2" /> Napaka pri nalaganju
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Profil podjetja</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-1">Podatki stranke za AI kontiranje</p>
        </div>
        <div className="flex items-center gap-2">
          {/* [PATCH pregled-vstop v1] vstop na pregled stranke za to podjetje */}
          <button onClick={() => navigate(`/onboarding?companyId=${COMPANY_ID}&veja=pregled`)}
            className="flex items-center gap-2 px-5 py-2.5 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-xl text-sm font-medium transition">
            <ShieldCheck className="w-4 h-4" /> Pregled stranke
          </button>
          <button onClick={() => navigate(`/onboarding?companyId=${COMPANY_ID}`)}
            className="flex items-center gap-2 px-5 py-2.5 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-xl text-sm font-medium transition">
            <Upload className="w-4 h-4" /> Uvozi šifrante in knjižbe
          </button>
          <button onClick={shrani} disabled={saving}
            className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-xl text-sm font-medium transition">
            {saving ? <Loader className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            Shrani
          </button>
        </div>
      </div>

      {/* PATCH_PROFIL_LAYOUT_V1: dvokolonski razpored kartic */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
      <div className="space-y-6">
      {/* [PATCH pravice-p4 v1] kartica Aplikacije podjetja odstranjena — urejanje v Upravljanju servisa → Podjetja */}
      {/* Osnovni podatki */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 space-y-4">
        <div className="flex items-center justify-between">
        <h2 className="font-semibold text-gray-900 dark:text-white flex items-center gap-2">
          <Building2 className="w-4 h-4 text-blue-500" /> Osnovni podatki
        </h2>
        <button type="button" onClick={osvezi} disabled={osvezujem}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 transition">
          {osvezujem ? <Loader className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
          {osvezujem ? 'Osvežujem…' : 'Osveži'}
        </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { field: 'name', label: 'Naziv podjetja', full: true },
            { field: 'short_name', label: 'Naziv za prikaz (do 30 znakov)', maxLength: 30,
              namig: 'Prikaze se v zgornji vrstici (dve vrstici). Prazno = polni naziv, odrezan na 30 znakov.' }, // [PATCH naziv-prikaz v3] (v2: 60)
            { field: 'tax_number', label: 'Davčna številka' },
            { field: 'vat_number', label: 'ID za DDV' },
            { field: 'registration_number', label: 'Matična številka' },
            { field: 'address', label: 'Naslov', full: true },
            { field: 'postal_code', label: 'Poštna številka' },
            { field: 'city', label: 'Kraj' },
          ].map(({ field, label, full, maxLength, namig }: any) => ( // [PATCH naziv-prikaz v1]
            <div key={field} className={full ? 'sm:col-span-2' : ''}>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
              <input
                value={data[field] || ''}
                onChange={e => set(field, e.target.value)}
                maxLength={maxLength}
                className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition"
              />
              {namig && <p className="text-[11px] text-gray-400 mt-1">{namig}</p>}{/* [PATCH naziv-prikaz v1] */}
            </div>
          ))}
        </div>
        <IbaniUrejanje companyId={COMPANY_ID} davcna={data?.tax_number} osveziTrigger={osveziStevec} />{/* [PATCH rtr-podjetje v3] */}
      </div>

      {/* Racunovodski program / izvoz */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 space-y-4">
        <h2 className="font-semibold text-gray-900 dark:text-white">Računovodski program (izvoz)</h2>
        <p className="text-xs text-gray-500 dark:text-gray-400">Program določa obliko izvoza. Za Vasco vpišite simbole za prenos v glavno knjigo.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Program</label>
            <select value={data.izvoz_program || 'vasco'} onChange={e => set('izvoz_program', e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white">
              <option value="vasco">Vasco</option>
              <option value="pantheon">Pantheon</option>
              <option value="opal">Opal (OpPIS)</option>{/* [PATCH opal-program v1] */}
              <option value="minimax">Minimax</option>
              <option value="drugo">Drugo</option>
            </select>
          </div>
          <div>{/* [PATCH opis-privzetek v1] */}
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Opis dokumenta ob izvozu</label>
            <select value={data.opis_privzetek || 'stevilka'} onChange={e => set('opis_privzetek', e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white">
              <option value="brez">Brez opisa</option>
              <option value="stevilka">Številka računa</option>
            </select>
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">Velja samo, kadar računovodja opisa ne vpiše ročno — vpisani opis ima vedno prednost.</p>
          </div>
        </div>
        {(data.izvoz_program || 'vasco') === 'vasco' && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 border-t border-gray-100 dark:border-gray-800">
            {[
              { field: 'prejeti', label: 'Simbol — prejeti računi', placeholder: 'npr. 2' },
              { field: 'izdani', label: 'Simbol — izdani računi', placeholder: 'npr. 1' },
              { field: 'blagajna', label: 'Simbol — blagajna', placeholder: 'npr. 3' },
              { field: 'banka', label: 'Simbol — bančni izpiski', placeholder: 'npr. 4' },
              { field: 'temeljnica', label: 'Simbol — temeljnice', placeholder: 'npr. 9' },
            ].map(({ field, label, placeholder }) => (
              <div key={field}>
                <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
                <input value={(data.vasco_simboli || {})[field] || ''}
                  onChange={e => set('vasco_simboli', { ...(data.vasco_simboli || {}), [field]: e.target.value })}
                  placeholder={placeholder}
                  className="w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white" />
              </div>
            ))}
          </div>
        )}
      </div>

      </div>{/* /levo */}
      <div className="space-y-6">{/* PATCH_PROFIL_LAYOUT_V3: desno davcni+SM */}
      {/* Davčni podatki */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 space-y-4">
        <h2 className="font-semibold text-gray-900 dark:text-white">Davčni podatki</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">SKD koda</label>
            <input value={data.skd_code || ''} onChange={e => set('skd_code', e.target.value)}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition"
              placeholder="npr. 69.200" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Opis dejavnosti</label>
            <input value={data.skd_description || ''} onChange={e => set('skd_description', e.target.value)}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition"
              placeholder="npr. Računovodske dejavnosti" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">DDV status</label>
            <select value={data.vat_status || ''} onChange={e => set('vat_status', e.target.value)}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition">
              <option value="">-- izberi --</option>
              {VAT_STATUSI.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="flex items-center gap-3 mt-2">
            <button
              type="button"
              onClick={() => set('ni_zavezanec_ddv', !data.ni_zavezanec_ddv)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${data.ni_zavezanec_ddv ? 'bg-amber-500' : 'bg-gray-300 dark:bg-gray-600'}`}
            >
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${data.ni_zavezanec_ddv ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
            <div>
              <div className="text-sm font-medium text-gray-900 dark:text-white">Ni zavezanec za DDV</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Vstopni DDV se za vse račune NE odbija (gre v strošek)</div>
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">DDV režim</label>
            <select value={data.vat_regime || ''} onChange={e => set('vat_regime', e.target.value)}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition">
              <option value="">-- izberi --</option>
              {VAT_REZIMI.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Velikost podjetja</label>
            <select value={data.company_size || ''} onChange={e => set('company_size', e.target.value)}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition">
              <option value="">-- izberi --</option>
              {VELIKOSTI.map(v => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>
          {/* [PATCH ddv-obdobje-profil-fe v1] DDV obdobje + opomnik na davcno blokado */}
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">DDV obdobje</label>
            <select value={data.ddv_obdobje || 'brez'} onChange={e => set('ddv_obdobje', e.target.value)}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition">
              <option value="brez">Brez</option>
              <option value="mesecno">Mesečno</option>
              <option value="kvartalno">Kvartalno</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Dni po preteku obdobja</label>
            <input type="number" min={0} max={60}
              disabled={(data.ddv_obdobje || 'brez') === 'brez'}
              value={data.ddv_opomnik_dni === undefined || data.ddv_opomnik_dni === null ? 10 : data.ddv_opomnik_dni}
              onChange={e => { const n = parseInt(e.target.value, 10); set('ddv_opomnik_dni', isNaN(n) ? 10 : Math.min(60, Math.max(0, n))); }}
              className="w-full px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm outline-none focus:border-blue-500 dark:text-white transition disabled:opacity-50" />
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Toliko dni po koncu obdobja te opozorimo na davčno blokado.</div>
          </div>
          <div className="flex items-center gap-3 mt-2 sm:col-span-2">
            <button
              type="button"
              disabled={(data.ddv_obdobje || 'brez') === 'brez'}
              onClick={() => set('ddv_opomnik', data.ddv_opomnik === false)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition disabled:opacity-40 ${data.ddv_opomnik !== false ? 'bg-blue-500' : 'bg-gray-300 dark:bg-gray-600'}`}
            >
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${data.ddv_opomnik !== false ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
            <div>
              <div className="text-sm font-medium text-gray-900 dark:text-white">Opominjanje na davčno blokado</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Ob vstopu v Dokumente predlagamo premik blokade, ko obdobje poteče.</div>
            </div>
          </div>
        </div>
      </div>


      {/* Stroskovna mesta */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 space-y-4">
        <h2 className="font-semibold text-gray-900 dark:text-white">Stroskovna mesta</h2>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => set('vodi_sm', !(data.vodi_sm ?? true))}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${(data.vodi_sm ?? true) ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600'}`}
          >
            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${(data.vodi_sm ?? true) ? 'translate-x-6' : 'translate-x-1'}`} />
          </button>
          <div>
            <div className="text-sm font-medium text-gray-900 dark:text-white">Vodenje stroskovnih mest</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">Ce je izklopljeno, se razdeljevanje po stroskovnih mestih izpusti (SM stolpec skrit, brez SM blokade pri potrditvi).</div>
          </div>
        </div>
      </div>

      {/* [PATCH nastavitve-zavihki v1] kartice Racun=placan, Zbirni kupec in
          Predpone internih stevilk -> Nastavitve (zavihka Prejeti/Izdani). */}
      </div>{/* /desno */}
      </div>{/* /dvokolonska mreza */}

      {/* [PATCH nastavitve-zavihki v1] kartici DDV konti in DDV klavzule
          -> Nastavitve (zavihka Prejeti/Izdani). */}
    </div>
  );
}
/* [PATCH nastavitve-zavihki v1] pomozni komponenti z dna te datoteke sta odstraneni:
   zavihka DDV kontov zivita na strani Nastavitve, iskalnik placnika pa je zdaj
   samostojna komponenta v mapi components/. */
